import './App.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/mainstyle.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './ProtectedRoute';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import LoginScreen from './LoginScreen/';
import Dashboard from './Dashboard/';
import LoadingSpinner from "./components/LoadingSpinner";

import ProvidersNriList from './ProvidersNri/ProvidersNriList';
import AddNriProvider from './ProvidersNri/AddNriProvider';
import Bookings from './NriBookings/Bookings';
import UpdatePassword from './NriUpdatePassword/UpdatePassword';
import assignProvider from './NriBookings/assignProvider';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import 'react-tagsinput/react-tagsinput.css'
import NriCouponListing from './NriCoupons/NriCouponListing';
import AddNriCoupon from './NriCoupons/AddNriCoupon';
import EditNriCoupon from './NriCoupons/EditNriCoupon';
import PermissionRoute from './PermissionRoute';
import { connect } from 'react-redux';
import { getUserData } from './actions/userdata';
import { toggleLoader } from './actions/loader';
import NriUserListing from './NriUsers/NriUserListing';
import NriUserDetail from './NriUsers/NriUserDetail';
import DashboardNri from './DashboardNri';
import MedicalCondition from './MedicalCondition/MedicalCondition';
import AddMedicalCondition from './MedicalCondition/AddMedicalCondition';
import NriViewUser from './NriViewUser';
import NriFaqListing from './NriFaqs/NriFaqListing';
import AddNriFaq from './NriFaqs/AddNriFaq';
import EditNriFaq from './NriFaqs/EditNriFaq';
import GynacList from './Gynac/GynacList';
import assessment from './assessment';
import EditAssessment from './assessment/EditAssessment';
import AddGynac from './Gynac/AddGynac';
import YogaTrainers from './Gynac/YogaTrainers';
import Pediatric from './Gynac/Pediatric';
import Reservations from './NriBookings/Reservations';
import Expenses from './NriBookings/Expenses';
import ExtraPayments from './NriBookings/ExtraPayments';
import ServicesList from './Services/ServicesList';

function App(props) {

  return (
    <React.Fragment>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={LoginScreen} />
          <ProtectedRoute exact path="/dashboard" component={Dashboard} />

          <ProtectedRoute exact path="/dashboard-nri" component={DashboardNri} />
          <ProtectedRoute exact path="/providers" component={ProvidersNriList} />
          <ProtectedRoute exact path="/add-providers" component={AddNriProvider} />
          <ProtectedRoute exact path="/bookings" component={Bookings} />
          <ProtectedRoute exact path="/expenses" component={Expenses} />
          <ProtectedRoute exact path="/extra-payments" component={ExtraPayments} />
          <ProtectedRoute exact path="/update-password" component={UpdatePassword} />
          <ProtectedRoute exact path="/assign-provider" component={assignProvider} />
          <ProtectedRoute exact path="/coupons" component={NriCouponListing} />
          <ProtectedRoute exact path="/add-coupon" component={AddNriCoupon} />
          <ProtectedRoute exact path="/edit-coupon/:id" component={EditNriCoupon} />
          <ProtectedRoute exact path="/faqs" component={NriFaqListing} />
          <ProtectedRoute exact path="/add-faq" component={AddNriFaq} />
          <ProtectedRoute exact path="/edit-faq/:id" component={EditNriFaq} />
          <ProtectedRoute exact path="/users" component={NriUserListing} />
          <ProtectedRoute exact path="/maternity-user-detail/:id" component={NriUserDetail} />
          <ProtectedRoute exact path="/medical-condition" component={MedicalCondition} />
          <ProtectedRoute exact path="/add-medical-condition" component={AddMedicalCondition} />
          <ProtectedRoute exact path="/view-user/:id" component={NriViewUser} />
          <ProtectedRoute exact path="/gynac-list" component={GynacList} />
          <ProtectedRoute exact path="/yoga-trainers" component={YogaTrainers} />
          <ProtectedRoute exact path="/pediatric" component={Pediatric} />
          <ProtectedRoute exact path="/services" component={ServicesList} />
          <ProtectedRoute exact path="/reservations" component={Reservations} />
          <ProtectedRoute exact path="/add-gynac" component={AddGynac} />
          <ProtectedRoute exact path="/assessment" component={assessment} />
          <ProtectedRoute exact path="/edit-assessment/:id" component={EditAssessment} />
        </Switch >
      </BrowserRouter >
      <LoadingSpinner />
    </React.Fragment >
  );
}


const mapDispatchToProps = {
  toggleLoader, getUserData
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userdata?.userData,

  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App);